import { render, staticRenderFns } from "./CreateBookingChannelForm.vue?vue&type=template&id=26e887a2&scoped=true&"
import script from "./CreateBookingChannelForm.vue?vue&type=script&lang=js&"
export * from "./CreateBookingChannelForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateBookingChannelForm.vue?vue&type=style&index=0&id=26e887a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e887a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VCol,VRow,VSelect,VTextField})
